import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取分类列表
export const getclassifyList = params => {
    return get("/admin/information/category", params);
};
// 新增分类
export const addclassify = params => {
    return post("/admin/information/category", params);
};
// 修改分类信息
export const editclassify = params => {
    return put(`/admin/information/category/${params.id}`, params);
};
// 删除分类
export const deleteclassify = params => {
    return del(`/admin/information/category/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/classify.js